document.addEventListener('DOMContentLoaded', async function() {

    const editorialContent = document.querySelector('.collection-editorial__content');
    if(editorialContent) {
        const editorialHandleInput = editorialContent.querySelector('input[name="editorial_handle"]');
        if(editorialHandleInput) {
            const editorialHandle = editorialHandleInput.value;
            await fetch('/pages/' + editorialHandle, {
                method: 'GET',
                headers: {
                    'Content-Type': 'text/html'
                }
            })
            .then(response => response.text())
            .then(async data => {
                // Create another main content container to parse the feched hhtml and extract the content of the main conten t container

                let parsedHTML = new DOMParser().parseFromString(data, 'text/html');
                const divSecondContent = parsedHTML.querySelector('#main-content');

                const createElement = document.createElement('div');
                createElement.innerHTML = divSecondContent.innerHTML;

                // Put this div close to the original main content contianier 
                // createElement.classList.add('invisible');
                createElement.setAttribute('id', 'editorial-main-content');

                const overlayLoading = document.getElementById('collection-editorial-overlay-loading');
                

                const mainContent = document.getElementById('main-content');
                mainContent.insertAdjacentElement('beforeBegin', createElement);
                
                await new Promise(resolve => setTimeout(resolve, 300));
                
                createElement.classList.add('invisible');
                overlayLoading.classList.add('invisible');

                // let parsedHTML = new DOMParser().parseFromString(data, 'text/html');
                // const insideSection = parsedHTML.querySelector('#main-content');
                // const html = insideSection.innerHTML;
                // editorialContent.innerHTML = html;
            })
            .catch(error => {
                console.error('Error fetching editorial content:', error);
            });

            const selectableElementsMenu = document.querySelector('#collection-header-container');
            const editorialContent = document.getElementById('editorial-main-content');
            editorialContent.insertAdjacentElement('beforeBegin', selectableElementsMenu);

            const editorialHref = selectableElementsMenu.querySelector('a[href="#collection-editorial-container"]');
            const collectionHref = selectableElementsMenu.querySelector('a[href="#collection-products-container"]');

            editorialHref.addEventListener('click', function(event) {
                event.preventDefault();
                editorialContent.classList.remove('invisible');
                const collectionProductsContainer = document.getElementById('main-content');
                collectionProductsContainer.classList.add('invisible');
                editorialHref.classList.add('active');
                collectionHref.classList.remove('active');
                window.scrollTo({ top: 0, left: 0, behavior: 'instant' });

                // Flickity measures its height once, on init, while this content may still
                // be hidden/unsettled. Force a re-measure now that it's actually visible,
                // otherwise the slideshow can be left with a stale, wrong cached height,
                // which then also throws off any GSAP ScrollTrigger further down the page
                // (e.g. Editorial Escalera) since it would have measured its own scroll
                // positions against that still-wrong layout. Resize Flickity first, wait
                // for that reflow to actually land, then refresh ScrollTrigger last.
                editorialContent.querySelectorAll('slide-show').forEach(function(slideshow) {
                    if (slideshow._flkty) slideshow._flkty.resize();
                });
                requestAnimationFrame(function() {
                    requestAnimationFrame(function() {
                        if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh();
                    });
                });
            });

            collectionHref.addEventListener('click', function(event) {
                event.preventDefault();
                editorialContent.classList.add('invisible');
                const collectionProductsContainer = document.getElementById('main-content');
                collectionProductsContainer.classList.remove('invisible');
                editorialHref.classList.remove('active');
                collectionHref.classList.add('active');
                window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
            });

        }

    }

});